import React from 'react';

export default function Modal({ isOpen, title, message, type = 'alert', onClose, onConfirm }) {
    if (!isOpen) return null;

    let titleColor = 'text-white';
    let buttonColor = 'bg-blue-600/80 hover:bg-blue-600 text-white';
    
    if (type === 'error' || type === 'alert') {
        titleColor = 'text-red-400';
        buttonColor = 'bg-red-500/20 hover:bg-red-500/40 text-red-400';
    } else if (type === 'success') {
        titleColor = 'text-green-400';
        buttonColor = 'bg-green-500/20 hover:bg-green-500/40 text-green-400';
    } else if (type === 'confirm') {
        titleColor = 'text-yellow-400';
    }

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-[100] p-4">
            <div className="glass-panel p-6 max-w-sm w-full animate-fade-in shadow-2xl shadow-black/50">
                {title && <h2 className={`text-xl font-bold mb-4 ${titleColor}`}>{title}</h2>}
                <div className="text-gray-200 mb-6 text-sm">
                    {message}
                </div>
                <div className="flex justify-end gap-3">
                    {type === 'confirm' ? (
                        <>
                            <button 
                                onClick={onClose} 
                                className="glass-button bg-white/5 hover:bg-white/10 text-gray-300 px-4 py-2 rounded-xl transition-all font-medium"
                            >
                                Cancelar
                            </button>
                            <button 
                                onClick={() => {
                                    onConfirm();
                                    onClose();
                                }} 
                                className="glass-button bg-red-500/80 hover:bg-red-500 text-white px-4 py-2 rounded-xl transition-all font-medium shadow-[0_0_15px_rgba(239,68,68,0.4)]"
                            >
                                Confirmar
                            </button>
                        </>
                    ) : (
                        <button 
                            onClick={onClose} 
                            className={`glass-button px-4 py-2 rounded-xl transition-all font-medium ${buttonColor}`}
                        >
                            Fechar
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
